import type { FieldMetaData } from "./fieldsMetaData";
import { createFieldMetaData } from "./createFieldMetaData";

export interface TourFormState {
    productionId: number;
    name: string;
    status: server.dto.StatusSmall;
}

export const mapTourToState = (tour: server.dto.Tour): TourFormState => ({
    productionId: tour.productionId,
    name: tour.name,
    status: tour.status,
});

export const getUpdateProductionInstruction = (state: TourFormState): server.dto.UpdateTourInstruction => ({
    productionId: state.productionId,
    name: state.name,
    statusId: state.status.statusId,
});

export interface TourFieldMetaData {
    name: FieldMetaData;
    status: FieldMetaData;
}

export const getTourFieldMetaData = (
    environment: server.dto.SelectedEnvironment,
    item: TourFormState,
    itemPermissions: server.dto.ObjectPermissions,
    hasMultipleStatuses: boolean,
): TourFieldMetaData => ({
    name: createFieldMetaData(
        !item.name,
        !item.name && !itemPermissions.canModify, //Hide when no name or when empty and read-only
        !itemPermissions.canModify, //External users cannot modify, even with modify permission
    ),
    status: createFieldMetaData(
        false, //Status is never empty
        !hasMultipleStatuses, //Hide when the client has only one status
        !itemPermissions.canModify,
    ),
});
